import styled from 'styled-components';
import DSTextBox from '../TextBox/DSTextBox.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react';
import 'react-desc';
import '../Input/DSInput.js';
import '../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import 'lodash';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../Input/showEllipsis.js';

var SearchBoxTextBox = /*#__PURE__*/styled(DSTextBox).withConfig({
  componentId: "sc-44ofm-0"
})(["padding-right:33px;"]);

export { SearchBoxTextBox };
//# sourceMappingURL=styled.js.map
